import { render, staticRenderFns } from "./PointRuleDetail.vue?vue&type=template&id=3e8e8072&scoped=true&"
import script from "./PointRuleDetail.vue?vue&type=script&lang=js&"
export * from "./PointRuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./PointRuleDetail.vue?vue&type=style&index=0&id=3e8e8072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e8072",
  null
  
)

export default component.exports